import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '@core/services/local-storage.service';
import { AppState } from '@core/store/app.reducer';
import { select, Store } from '@ngrx/store';
import * as clientsActions from '@core/store/selectClient/selectClient.actions';
import * as EssentialsActions from '@core/store/essentials/essentials.actions';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { catchError, debounceTime, distinctUntilChanged, map, of, shareReplay, Subscription, take } from 'rxjs';
import { TitleCasePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@core/services/authentication/auth.service';
import * as authActions from '@core/store/auth/auth.actions';
import * as shoppingActions from '@core/store/shoppingCar/shoppingCar.actions';
import { CarsState } from '@core/interfaces/cars';
import { UtilsService } from '@core/services/utils/utils.service';
import { DialogCloseSesionComponent } from '../modals/dialog-close-sesion/dialog-close-sesion.component';
import {
  Categories_request,
  categories_response,
} from '@core/interfaces/categories';
import { GtmEventService } from '@core/analytics/gtm-events.service';
import { CategoriesService } from '@core/services/categories/categories.service';
import { selectLoginUserInfo } from '@core/store/app.selectors';
import { OrderChangeService } from '@core/services/orders/orderChange.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ShowNotificationsComponent } from '../header/show-notifications/show-notifications.component';
import { NotificationsService } from '@core/services/notifications/notifications.service';
import { BrazeService } from '@core/services/braze/braze.service';
@Component({
  selector: 'app-header-seller',
  templateUrl: './header-seller.component.html',
  styleUrls: ['./header-seller.component.scss'],
  providers: [TitleCasePipe],
})
export class HeaderClientComponent implements OnInit, OnDestroy {
  dataConvertClients: any;
  dataConvertClientSelect: any;
  urlActive!: string;
  user!: any;
  @ViewChild('drawerProfile') sidenavProfile!: MatSidenav;
  @ViewChild('drawerNotifications') drawerNotifications!: MatSidenav;
  @ViewChild('drawerCar') viewCar!: MatSidenav;
  @ViewChild(ShowNotificationsComponent) showNotificationsComponent!: ShowNotificationsComponent;
  notificationCount = 0;
  selectSuscription!: Subscription;
  loginSuscription$!: Subscription;
  @Output() nameSelect = new EventEmitter<string>();
  @ViewChild(MatMenuTrigger) myMenu!: MatMenuTrigger;
  @ViewChild('drawer')
  sidenav!: MatSidenav;
  public carSubscription!: Subscription;
  carsState!: CarsState;
  car!: any;
  badge = 0;
  totalPriceAdd: any;
  actualRoute: any;
  lockCart: boolean = false;
  readonly classCar: string = '';
  selectedClient: any;
  listCategories: Array<categories_response> = [];
  searchTextValue = '';
  loadingSearch = false;
  errorSearch = false;
  searchResponse$= of([]);
  dataCurrentAccount: any;
  readonly hidden = false;
  unitSelect!: Categories_request;
  initialDateSearch = [];
  @ViewChild('search_opacity_seller ')
  search_opacity_seller!: ElementRef;
  @ViewChild('drawerSeller') sidenavSeller!: MatSidenav;
  @ViewChild('drawerSellerMobile') sidenavSellerMobile!: MatSidenav;
  categoriesSuscription$!: Subscription;
  private isFirstClientSelectEmit = true;
  isMobile = false;
  constructor(
    private readonly _localStorageService: LocalStorageService,
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly titlecasePipe: TitleCasePipe,
    private readonly _authService: AuthService,
    public readonly dialogCloseSesion: MatDialog,
    private readonly ref: ChangeDetectorRef,
    private readonly renderer: Renderer2,
    private readonly _gtmEventService: GtmEventService,
    private readonly _categoriesService: CategoriesService,
    private readonly orderChangeService: OrderChangeService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly notificationsService: NotificationsService,
    private readonly brazeService: BrazeService,
  ) { }
  readonly options = [
    { label: 'Inicio', link: '/main/inicio', icon: 'home' },
    { label: 'Subir pedido', link: '/main/subir-pedido', icon: 'downloads' },
    {
      label: 'Cuenta corriente',
      link: '/main/cuenta-corriente',
      icon: 'account',
    },
  ];
  readonly optionsResponsive = [
    { show: true, label: 'Inicio', link: '/main/inicio', icon: 'home' },
    // { show: true, label: 'Imperdonables', link: '/main/los-infaltables', icon: 'unmissables', isNew: true },
    // { show: true, label: 'Infaltables', link: '/main/los-infaltables', icon: 'essentials-medal', isNew: true },
    {
      show: true,
      label: 'Datos del cliente',
      link: '/main/inicio',
      icon: 'storefront',
    },
    {
      show: true,
      label: 'Subir pedido',
      link: '/main/subir-pedido',
      icon: 'downloads',
    },
    {
      show: true,
      label: 'Avance de ventas',
      link: '/main/avances-ventas',
      icon: 'advance',
    },
    {
      show: true,
      label: 'Reconocimientos',
      link: '/main/reconocimientosdetalle',
      icon: 'recognitions',
    },
    {
      show: true,
      label: 'Cuenta corriente',
      link: '/main/cuenta-corriente',
      icon: 'account',
    },
    {
      show: true,
      label: 'Historial de compras',
      link: '/main/historial-compras',
      icon: 'history',
    },
    { show: true, label: 'Facturas', link: '', icon: 'bills' },
       {
      show: true,
      label: 'Mis Reclamos',
      link: '/main/mis-reclamos',
      icon: 'icon-callCenter_black'
       },
    { show:false, label: 'Aliados Beneficios', link: '/main/ali-socios', icon: 'redirect-partners-ALI' },
    { show:false, label: 'Mis Reclamos', link: '/main/mis-reclamos', icon: 'redirect-partners-ALI' },
    { show: true, label: 'Aliados Puntos', link: '/main/aliados', icon: 'allies' }
  ];

  readonly skeletonThemeWide = {
    height: '8px',
    width: '200px',
    'border-radius': '8px',
    display: 'flex',
    'align-items': 'center',
    'margin-bottom': '0px'
  };

  readonly skeletonThemeSmall = {
    height: '8px',
    width: '100px',
    'border-radius': '8px',
    display: 'flex',
    'align-items': 'center',
    'margin-bottom': '0px',
    'margin-top': '8px'
  };

  ngOnInit() {
    this.checkMobile();
    this.initConvertData();
    this.initStore();
    this.initialData();
    // El badge se actualiza vía unreadCountChange del hijo (app-show-notifications)
  }

  initConvertData() {
    const client = this._localStorageService.getItem('clients');

    this.unitSelect = this._localStorageService.getItem('clientSelect');
    this.dataConvertClients = client.map((data: any) => {
      return {
        ...data,
      };
    });
  }

  initStore() {
    this.loginSuscription$ = this.store
      .select('auth')
      .subscribe((loginUser) => {
        if (loginUser) {
          this.user = loginUser?.user;
        }
      });
    this.selectSuscription = this.store
      .select('clientSelect')
      .subscribe((clientSelect: any) => {
        this.dataConvertClientSelect = this.dataConvertClients.find(
          (item) => item.code == clientSelect.client.code
        );
        this.countBadgeCar();
        if (!this.isFirstClientSelectEmit) {
          // Pasar params explícitos del cliente NUEVO (clientSelect ya tiene el valor actualizado del store)
          const client = clientSelect?.client;
          const params = client?.code && client?.sector
            ? { sector: client.sector, code: client.code }
            : undefined;
          this.showNotificationsComponent?.loadNotifications(params);
        }
        this.isFirstClientSelectEmit = false;
        this.ref.detectChanges();
      });
  }

  initialData() {
    this.getCategoriesList(this.unitSelect);
  }

  getCategoriesList(data) {
    this.unsubscribeFromStore();
    this.categoriesSuscription$ = this.store
      .pipe(select(selectLoginUserInfo))
      .subscribe((value) => {
        this.unitSelect = value;
        // Clona el objeto para evitar modificar el original
        const userWithType = {
          ...value,
          userType: (this.user?.type === 'Cliente') ? 'C' : 'S',
        };

        this._categoriesService
          .getCategories(userWithType)
          .pipe(take(1))
          .subscribe({
            next: (res: any) => {
              this.listCategories = res;
            },
            error: (err: Error) => { },
          });
      });
  }

  ngAfterContentInit() {
    this.urlActive = this.router.url;
  }
  changeValue(clientSelect: any) {
    this.router.navigate(['/main/inicio']);

    let client = clientSelect.value;
    this.actualRoute = this.router.url;
    this.store.dispatch(
      clientsActions.setClients({ clients: client ? client : '' })
    );

    // Re-login en Braze con el nuevo cliente seleccionado desde el header
    if (client?.code) {
      const brazePayload = {
        email: client.email ?? '',
        name: client.name ?? '',
      };
      // console.log('[Braze] Re-login cliente (cambio desde header) →', {
      //   userId: client.code,
      //   ...brazePayload,
      // });
      this.brazeService.identifyUser(client.code, brazePayload);
    }
  }

  disabledClient() {
    return this.orderChangeService.getButtonState();
  }
  clientSelect() {
    this.myMenu.closeMenu();
  }
  openMenu() {
    this.sidenav.toggle();
  }

  openProfile() {
    this.sidenavProfile.toggle();
  }
  closeProfile(event: string) {
    this.sidenavProfile.close();

    if (event === 'logout') {
      setTimeout(() => {
        this.openModalCloseSesion();
      }, 350);
    }
  }
  transformToTitleCase(value: any): any {
    return this.titlecasePipe.transform(value);
  }
  openModalCloseSesion() {
    const dialogRef = this.dialogCloseSesion.open(DialogCloseSesionComponent, {
      width: '31rem',
      data: {},
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data?.status) {
        this.store.dispatch(authActions.unsetUser());
        this.store.dispatch(shoppingActions.unsetCar());
        this.store.dispatch(clientsActions.unsetClients());
        this.store.dispatch(EssentialsActions.clearAll());
        this._authService.logout();
      }
    });
  }

  openCar() {
    if (this.badge !== 0 && this.router.url !== '/main/confirmacion') {
      if (!this.lockCart) {
        this.router.navigate(['/main/confirmacion']);
      }
    }
  }

  closeCar() {
    this.viewCar.close();
  }

  get notificationBadgeLabel(): string {
    return this.notificationCount > 99 ? '99+' : String(this.notificationCount);
  }

  get notificationBadgeVariant(): 'cliente' | 'vendedor' {
    return this.notificationsService.getBadgeVariant();
  }

  /** Params para notificaciones: sector y code del cliente seleccionado (header-seller solo se muestra en /main con cliente) */
  get notificationParams(): { sector?: string; code?: string } {
    const client = this._localStorageService.getItem('clientSelect');
    if (client?.code && client?.sector) {
      return { sector: client.sector, code: client.code };
    }
    return {};
  }

  openNotifications(): void {
    this.drawerNotifications?.toggle();
  }

  closeNotifications(): void {
    this.drawerNotifications?.close();
  }

  countBadgeCar() {
    this.carSubscription = this.store
      .select('carsState')
      .subscribe((carsState) => {
        this.carsState = carsState;

        if (carsState) {
          const tempCar = carsState.cars.find(
            (car) =>
              car.unitBussines?.toLowerCase() ==
              this.dataConvertClientSelect.name.toLowerCase()
          );
          this.car = tempCar ? tempCar : undefined;
          this.badge = this.car?.products ? this.car.products.length : 0;

          // Mover la suma del precio total dentro de una promesa
          Promise.resolve().then(() => {
            this.totalPriceSum();
            this.ref.detectChanges();
          });
        }
      });
  }

  totalPriceSum() {
    if (this.car && this.car.products) {
      const totalPriceAdd = this.car.products
        .reduce((acc: any, product: any) => {
          return (
            acc +
            Number.parseFloat(String(product.totalPrice).replace(/[^0-9-.]/g, ''))
          );
        }, 0)
        .toFixed(2);
      this.totalPriceAdd = UtilsService.formatTotalNumber(totalPriceAdd);
    } else {
      this.totalPriceAdd = '0';
    }
  }

  //restricciones del input
  countProduct(e: any) {
    const replace = e.e.replace(/[^0-9-.]/g, '');
    let countFormat = Number.parseFloat(replace);
    let tempCount: any = 0;
    if (Number.isNaN(countFormat) || countFormat == 0) {
      tempCount = '';
      countFormat = 0;
    } else if (countFormat < 0) {
      countFormat = countFormat * -1;
      tempCount = UtilsService.formatNumber(countFormat);
    } else if (countFormat > 9999) {
      tempCount = '9,999';
      countFormat = 9999;
    } else {
      tempCount = UtilsService.formatNumber(countFormat);
    }
    this.searchAndModifyProduct(tempCount, countFormat, e.p, Number.parseInt(e.e));
    this.ref.detectChanges();
  }
  searchAndModifyProduct(value: any, inputValue: any, p: any, count: number) {
    const cars = this.carsState.cars.map((car) => {
      const products = car.products.map((product) => {
        let totalPrice = product.totalPrice;
        if (count >= p.minimumPurchase && p.minimumPurchase != 0) {
          if (product.sku == p.sku) {
            totalPrice = UtilsService.formatTotalNumber(
              (inputValue * Number.parseFloat(p.wholesalePriceDiscountVAT)).toFixed(2)
            );
            return {
              ...product,
              count: value,
              totalPrice: totalPrice,
            };
          } else {
            return { ...product };
          }
        } else {
          if (product.sku == p.sku) {
            totalPrice = UtilsService.formatTotalNumber(
              (inputValue * Number.parseFloat(p.wholesalerPriceIva)).toFixed(2)
            );
            return {
              ...product,
              count: value,
              totalPrice: totalPrice,
            };
          } else {
            return { ...product };
          }
        }
      });
      return {
        ...car,
        products: products,
      };
    });
    this.totalPriceSum();
    this.store.dispatch(shoppingActions.setCar({ cars }));
  }
  deleteProduct(p: any) {
    const cars = this.carsState.cars.map((car: any) => {
      if (car.unitBussines === this.dataConvertClientSelect.name) {
        const products = car.products.filter((product) => {
          return product.sku != p.sku;
        });
        return {
          ...car,
          products: products,
        };
      } else {
        return car;
      }
    });
    this.store.dispatch(shoppingActions.setCar({ cars }));
    if (this.badge === 0) {
      this.closeCar();
    }
  }
  deleteCar() {
    const cars = this.carsState.cars.map((car: any) => {
      if (car.unitBussines === this.dataConvertClientSelect.name) {
        return {
          ...car,
          products: [],
        };
      } else {
        return {
          ...car,
        };
      }
    });

    this.store.dispatch(shoppingActions.setCar({ cars }));
  }
  categoriesEmit(a: any, device: 'mobile' | 'desktop') {
    // Al tener un solo sidenav, solo togglear uno
    this.sidenavSeller.toggle();
  
    // Construimos queryParams
    const queryParams: any = {
      categoryCode: a?.category?.categoryCode,
      categoryName: a?.category?.categoryName,
    };
  
    if (a?.type !== 'category' && a?.brandCode) {
      queryParams.brandCode = a.brandCode;
    }
  
    this.router.navigate(['/tienda/busqueda'], { queryParams });
  }
  
  clickSearchBar() {
    this._gtmEventService.clickSearchBarEvent();
  }
  getList(text) {
    let data: {
      code: string;
      sector: string;
      zone: string;
      schema: string;
      segment: string;
      description?: string; // Agrega la propiedad 'description' como opcional
      userType?: string;
    } = {
      code: this.unitSelect.code,
      sector: this.unitSelect.sector,
      zone: this.unitSelect.zone,
      schema: this.unitSelect.schema,
      segment: this.unitSelect.segment,
    };

    data.description = text;
    data.userType = (this.user?.type === 'Cliente') ? 'C' : 'S';
    if (text && text.length >= 3 && text.length <= 50) {
      this.loadingSearch = true;
      this.errorSearch = false;
      this.searchResponse$ = this._categoriesService
        .getSearchCategories(data)
        .pipe(
          take(1),
          debounceTime(300),
    distinctUntilChanged(),
           // debounceTime(500),
           map((res) => {
            if (res) {
              this.loadingSearch = false;
              let resultado = res;
              if (res.length > 1) {
                const tieneActivos = res.some(item => !item.discontinued);
                if (tieneActivos) {
                  // Si hay productos activos, quitar todos los descontinuados
                  resultado = res.filter(item => !item.discontinued);
                } else {
                  // Todos están descontinuados, mantener solo el primero
                  resultado = [res[0]];
                }
              }

              this.saveInitialDate(res);

              if (resultado && resultado.length > 0) {
                this.addOpacityAutocomplete();
              } else {
                this.removeOpacityAutocomplete();
              }

              return resultado;
            } else {
              this.loadingSearch = false;
              this.errorSearch = false;
              this.saveInitialDate(res);
            }
          }),
          catchError((error) => {
            this.loadingSearch = false;
            this.errorSearch = true;
            return of([]);
          }),
          
        ),shareReplay(1) // para que la llamada se comparta y no se duplique
        ;
    } else {
      this.removeOpacityAutocomplete();
     this.searchResponse$ = of([]);
    }
  }
  mouseUp(event) {
    //vaciar data
    this.removeOpacityAutocomplete();
    if (event && event.length < 1) {
      this.searchResponse$ = of([]);
    }
  }
  mouseClickInput(text) {
    if (
      text &&
      this.initialDateSearch &&
      text.length >= 3 &&
      this.initialDateSearch.length > 0
    ) {
      this.addOpacityAutocomplete();
    } else {
      this.removeOpacityAutocomplete();
    }
  }
  clickUploadOrder() {
    this._gtmEventService.clickUploadOrderEvent();
  }
  selectConfirmation() {
    this.redirect();
  }
  clickMyAccount() {
    this._gtmEventService.clickMyAccountEvent();
  }
  searchEngineSelectedProduct(product: any) {
    const value = product?.sku;
    const description = product?.description ?? '';
    const gtmMeta = this._gtmEventService.buildPresentationMetaFromSearchAutocomplete(
      product,
      this.initialDateSearch || []
    );
    this._gtmEventService.clickSearchResultEvent(description, gtmMeta);
    if (gtmMeta) {
      this._gtmEventService.scheduleSkipViewSearchResultEventAfterAutocomplete();
    }
    this.initialDateSearch.forEach((item: any) => {
      item.select = item.sku === value ? true : false;
    });
    this._localStorageService.setItem(
      'listProductSearch',
      this.initialDateSearch
    );
    this.router.navigate(['/tienda/busqueda'], {
      queryParams: { productos: value },
    });
    this.removeOpacityAutocomplete();
  }
  saveInitialDate(response) {
    this.initialDateSearch = response;
  }
  openCategories(value: string) {
    if (this.sidenavSeller) {
      this.sidenavSeller.toggle();
    } else {
      console.error('sidenavSeller no está definido');
    }
    this._gtmEventService.clickCategoriesEvent();
  }
  
  addOpacityAutocomplete() {
    this.renderer.addClass(
      this.search_opacity_seller.nativeElement,
      'class-opacity'
    );
    this.openedStart();
  }

  removeOpacityAutocomplete() {
    this.renderer.removeClass(
      this.search_opacity_seller.nativeElement,
      'class-opacity'
    );
    this.closedStart();
  }
  redirect() {
    this.router.navigate(['/tienda/mi-carrito']);
    this.closedStart();
  }
  openedStart() {
    this.renderer.addClass(document.body, 'modal-open');
  }

  closedStart() {
    this.renderer.removeClass(document.body, 'modal-open');
  }

  getProductStatus(product: any): { class: string, text: string } | null {
    if (!product) return null;
  
    if (product.isRecommended) {
      return { class: 'new-label', text: '¡Nueva presentación!' };
    }
  
    if (product.discontinued && !product.newSku) {
      return { class: 'discontinued-label', text: 'Descontinuado' };
    }
  
    if (!product.discontinued && !!product.disableCode) {
      return { class: 'not-available-label', text: 'No disponible temporalmente' };
    }
  
    return null;
  }
  

checkMobile() {
  // Define aquí el ancho máximo para considerar "mobile"
  const maxMobileWidth = 767; 
  this.isMobile = window.innerWidth <= maxMobileWidth;
  // Si quieres, puedes hacer algo cuando cambia el valor:
  // console.log('Is mobile?', this.isMobile);
}
@HostListener('window:resize', ['$event'])
onResize(event: Event): void {
  this.checkMobile();
}
  unsubscribeFromStore() {
    if (this.categoriesSuscription$) {
      this.categoriesSuscription$.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.loginSuscription$.unsubscribe();
    this.selectSuscription.unsubscribe();
    this.unsubscribeFromStore();
  }
}
